/**
 * EE「认证安全」：使用本仓 containers/IAM/router（@IAM），不用 CE 的 IAM。
 * 消息中心由 Monitor 承载，此处排除避免 path 重复。
 * 安全建议等增量在 iamExtras；组织/日志/流程在 eeRouter/iam.js。
 */
import i18n from '@/locales'

import Iam from '@IAM/router'

import { filterMenuPaths } from '@generalScope/utils/composeMenus'
import { securitySuggestMenu } from '@generalScope/eeMenus/iamExtras'

// 与旧 EE 一致：消息中心挂在「监控」，不在「认证安全」
const MONITOR_OWNED_PATHS = [
  '/notification',
  '/notify-topic',
  '/notifyconfig',
  '/contact',
  '/robot',
]

const SUB_GROUPS = ['certification', 'security', 'security']

const iamMenusWithSubGroup = filterMenuPaths(
  Iam.menus.map((menu, index) => {
    const next = {
      ...menu,
      subGroup: SUB_GROUPS[index] || 'security',
    }
    if (menu.submenus) {
      next.submenus = [...menu.submenus]
    }
    return next
  }),
  { exclude: MONITOR_OWNED_PATHS },
)

export default {
  index: 91,
  meta: {
    label: i18n.t('dictionary.menu_iam_security'),
    t: 'dictionary.menu_iam_security',
    icon: 'menu-iam',
  },
  menus: [
    ...iamMenusWithSubGroup,
    securitySuggestMenu,
  ],
}
